export default __webpack_public_path__ + "static/media/thescorpioncavenormal.2f8f9cb7.jpg";